import { render, staticRenderFns } from "./CorrectionStatistics.vue?vue&type=template&id=3f5b0fea&scoped=true&"
import script from "./CorrectionStatistics.vue?vue&type=script&lang=js&"
export * from "./CorrectionStatistics.vue?vue&type=script&lang=js&"
import style0 from "./CorrectionStatistics.vue?vue&type=style&index=0&id=3f5b0fea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5b0fea",
  null
  
)

export default component.exports